// extracted by mini-css-extract-plugin
export default {"titleHeader":"TDacPY_xPGkUNrYa6Aqk","preTitle":"FcIA7iwY6xbivkLx0yKF","postTitle":"sjmEAxDoEfR1HaJzBZKA","title":"GdA5I9Ju76FpQMYtxsaq"};